// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"RecipeTagDropdown_ItemsWrapper__ddKg+","Slide":"RecipeTagDropdown_Slide__Y4yli","Active":"RecipeTagDropdown_Active__YkpDO"};